import BlackAdjustableAttache from "../../assets/blackAdjustableAttache.png";
import BlackAttache from "../../assets/blackAttache.png";
import BlackAttache180 from "../../assets/blackAttache180.png";
import BlackPenture from "../../assets/blackPenture.png";
import BlackSpigot from "../../assets/blackSpigot.png";
import project1 from "../../assets/project1.jpeg";
import project2 from "../../assets/project2.jpeg";
import project3 from "../../assets/project3.jpeg";
import SilverAdjustableAttache from "../../assets/silverAdjustableAttache.png";
import SilverAttache from "../../assets/silverAttache.png";
import SilverAttache180 from "../../assets/silverAttache180.png";
import SilverPenture from "../../assets/silverPenture.png";
import SilverSpigot from "../../assets/silverSpigot.png";
import { MaterialType, Province } from "../../types/canvasTypes";
import "./Step.css";

import { useOptionContext } from "../../context/OptionContext";
import { Link } from "react-router-dom";
import i18n from "../../i18";
import { t } from "i18next";

const BlackMateriaImagelList = [
  {
    name: "Black Spigot",
    image: BlackSpigot,
  },
  {
    name: "Black Attache",
    image: BlackAttache,
  },
  {
    name: "Black Attache 180",
    image: BlackAttache180,
  },
  {
    name: "Black addjustable Attache",
    image: BlackAdjustableAttache,
  },
  {
    name: "Black Penture",
    image: BlackPenture,
  },
];
const SilverMateriaImagelList = [
  {
    name: "Silver Spigot",
    image: SilverSpigot,
  },
  {
    name: "Sivler Attache",
    image: SilverAttache,
  },
  {
    name: "Sivler Attache 180",
    image: SilverAttache180,
  },
  {
    name: "Sivler addjustable Attache",
    image: SilverAdjustableAttache,
  },
  {
    name: "Sivler Penture",
    image: SilverPenture,
  },
];

const projectImagesList = [
  {
    name: "Project 1",
    image: project1,
  },
  {
    name: "Project 2",
    image: project2,
  },
  {
    name: "Project 3",
    image: project3,
  },
];

const StepOne = () => {
  const { materialType, setMaterialType } = useOptionContext();
  const { height, setHeight } = useOptionContext();
  const { scale, setScale } = useOptionContext();
  const { province, setProvince } = useOptionContext();

  const handleMaterialChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    setMaterialType(e.target.value as MaterialType);
  };

  const handleHeightChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    setHeight(parseInt(e.target.value) as 36 | 42 | 48);
  };
  const handleProvinceChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    if ((e.target.value as Province) === Province.Ontario)
      i18n.changeLanguage("en");
    else i18n.changeLanguage("fr");
    setProvince(e.target.value as Province);
  };

  const handleScaleChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    setScale(parseFloat(e.target.value) as 2.9 | 1.5 | 1);
  };

  const renderProjectImages = () => {
    return projectImagesList.map((image) => {
      return (
        <img
          key={image.name}
          src={image.image}
          alt={image.name}
          height={125}
          style={{
            objectFit: "cover",
            backgroundColor: "transparent",
            backgroundClip: "content-box",
            justifySelf: "flex-start",
          }}
        />
      );
    });
  };

  const renderImages = () => {
    if (materialType === MaterialType.Silver) {
      return SilverMateriaImagelList.map((image) => {
        return (
          <img
            key={image.name}
            src={image.image}
            alt={image.name}
            height={115}
            style={{
              mixBlendMode: "multiply",
              objectFit: "cover",
              backgroundColor: "transparent",
              backgroundClip: "content-box",
              justifySelf: "flex-start",
            }}
          />
        );
      });
    } else {
      return BlackMateriaImagelList.map((image) => {
        return (
          <img
            src={image.image}
            alt={image.name}
            height={115}
            style={{
              mixBlendMode: "multiply",
              objectFit: "cover",
              backgroundColor: "transparent",
              backgroundClip: "content-box",
              justifySelf: "flex-start",
            }}
          />
        );
      });
    }
  };

  return (
    <div className="step-container">
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          width: "100%",
        }}
      >
        <h1>{t("firstStep")}</h1>
        <Link to="/quotations" style={{ alignSelf: "center" }}>
          <button>Quotations</button>
        </Link>
      </div>
      <div className="custom-dropdown">
        <p>{t("chooseProvince")}</p>
        <select
          className="dropdown-select"
          style={{ height: "40px" }}
          id="mySelect"
          value={`${province}`}
          onChange={handleProvinceChange}
        >
          <option value="QUEBEC">QUEBEC</option>
          <option value="ONTARIO">ONTARIO</option>
        </select>
      </div>
      <div className="custom-dropdown">
        <p>{t("chooseTheHeightOfGlass")}</p>
        <select
          className="dropdown-select"
          style={{ height: "40px" }}
          id="mySelect"
          value={`${height}`}
          onChange={handleHeightChange}
        >
          <option value="48">48"</option>
          <option value="42">42"</option>
          <option value="36">36"</option>
        </select>
      </div>
      <div className="custom-dropdown">
        <p>{t("chooseTheColor")}</p>
        <select
          className="dropdown-select"
          value={materialType}
          onChange={handleMaterialChange}
          style={{ height: "40px" }}
          id="materialSelect"
        >
          <option value="Stainless">{MaterialType.Silver}</option>
          <option value="Stainless Noir">{MaterialType.Black}</option>
        </select>
        <div style={{ gap: "10px", display: "flex" }}>{renderImages()}</div>
      </div>
      <div className="custom-dropdown">
        <p>{t("chooseTheSizeOfTheProject")}</p>
        <select
          className="dropdown-select"
          onChange={handleScaleChange}
          style={{ height: "40px" }}
          id="selectedScale"
          value={`${scale}`}
        >
          <option value="2.9">{t("small")} (0 - 200'')</option>
          <option value="1.5">{t("medium")} (200'' - 600'')</option>
          <option value="1">{t("large")} (600''+)</option>
        </select>
        <div
          style={{
            gap: "10px",
            display: "flex",
            justifyContent: "center",
            marginTop: "10px",
          }}
        >
          {renderProjectImages()}
        </div>
      </div>
    </div>
  );
};
export default StepOne;
